// packages import
import { Box, Button, CircularProgress, DialogActions, Typography } from '@mui/material'
import { FC, useContext } from 'react'
// component import
import { Alert } from '../../common/Alert'
import { CustomModal } from '../../common/CustomModal'
/// others
import { useDeleteCaseMutation } from '../../../../generated'
import { CANCEL, NOT_APPLICABLE, SOMETHING_WENT_WRONG } from '../../../constants'
import { AppContext, CaseContext } from '../../../context'
import { ActionType } from '../../../context/AppContextReducer'
import { DeleteCaseProps } from '../../../interfaceTypes'
import { capitalizeCase } from '../../../utils'
import { CaseActionType } from '../caseReducer'

export const DeleteCase: FC<DeleteCaseProps> = ({ refetch }) => {
  const { dispatch, isDeleteCaseOpen } = useContext(AppContext)
  const { currentCase, dispatch: caseDispatch } = useContext(CaseContext)
  const { title, id: currentCaseId, caseNumber, court } = currentCase || {}
  const { name: courtName } = court || {}

  const [deleteCase, { loading }] = useDeleteCaseMutation({
    variables: undefined,

    onError() {
      Alert.error(SOMETHING_WENT_WRONG)
    },

    onCompleted(data) {
      if (data) {
        const { deleteCase } = data

        if (deleteCase) {
          const { response } = deleteCase
          const { status } = response || {}

          if (status === 200) {
            Alert.success(response?.message || '')
            caseDispatch && caseDispatch({ type: CaseActionType.SET_CURRENT_CASE, currentCase: null })
            dispatch({ type: ActionType.SET_IS_DELETE_CASE_OPEN, isDeleteCaseOpen: false })
            refetch && refetch()
          }
        }
      }
    }
  })

  const handleClose = () => dispatch({ type: ActionType.SET_IS_DELETE_CASE_OPEN, isDeleteCaseOpen: false })

  const handleDelete = async () => {
    if (currentCaseId) {
      await deleteCase({
        variables: {
          deleteCaseInput: {
            id: currentCaseId
          }
        }
      })
    }
  }

  return (
    <CustomModal title="Delete Matter" isOpen={isDeleteCaseOpen} handleClose={handleClose}>
      <Typography variant="body1">You are about to delete the following matter:</Typography>
      <Box mt={1}>
        <Typography variant="body1">
          <Typography component="span" fontWeight={500}>
            Title:{' '}
          </Typography>{' '}
          {title || ''}
        </Typography>

        <Typography variant="body1">
          <Typography component="span" fontWeight={500}>
            Matter Number:{' '}
          </Typography>
          {caseNumber || NOT_APPLICABLE}
        </Typography>

        <Typography variant="body1">
          <Typography component="span" fontWeight={500}>
            Court Name:{' '}
          </Typography>
          {capitalizeCase(courtName?.toLowerCase() || '') || ''}
        </Typography>
      </Box>

      <DialogActions sx={{ padding: '30px 0 0', flexWrap: 'wrap' }}>
        <Button onClick={handleClose} variant="outlined" aria-label={CANCEL}>
          {CANCEL}
        </Button>

        <Button
          disabled={loading}
          onClick={handleDelete}
          color="primary"
          variant="contained"
          endIcon={loading && <CircularProgress size={20} color="inherit" />}
          aria-label="delete case"
        >
          Delete Matter
        </Button>
      </DialogActions>
    </CustomModal>
  )
}
